import { createContext, type Dispatch, type SetStateAction } from 'react';

export const CollapseContext = createContext<{
  showBody: boolean;
  setShowBody: Dispatch<SetStateAction<boolean>>;
  bodyId: string;
}>({
  bodyId: '',
  showBody: true,
  setShowBody: () => {},
});
